<template>
  <div class="assistant">
    <div class="assistant-content">
      <h1 v-text="$t('screen.priceWidget.assistant.content.title')" />
      <p v-text="$t('screen.priceWidget.assistant.content.text')" />

      <ovp-button
        :href="$t('screen.priceWidget.assistant.content.link')"
        primary
        v-text="$t('screen.priceWidget.assistant.content.button')"
      />
    </div>
    <div class="assistant-image">
      <img alt="assistant_image" class="assistant-image__image" :src="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Assistant',

  data() {
    return {
      image: require('@/assets/Kundenberatung.jpg'),
    }
  },
}
</script>

<style name="mobile" scoped>
.assistant {
  color: var(--c-black);
  font-size: 15px;
  line-height: 20px;
  padding: 20px;

  background-color: var(--c-white);

  h1 {
    font-size: 30px;
    line-height: 35px;
    color: var(--c-black);
    margin: 0;
  }

  h2 {
    font-size: 25px;
    line-height: 30px;
  }

  p {
    margin: 20px 0;
  }

  .button {
    font-weight: bold;
  }

  &-image {
    display: none;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .assistant {
    display: grid;
    grid-template-areas: 'content image';
    grid-template-columns: 1fr 200px;
    grid-gap: 20px;

    &-content {
      grid-area: content;
    }

    &-image {
      grid-area: image;
      padding: 55px 0 0 0;
      display: initial;

      &__image {
        height: 140px;
      }
    }
  }
}
</style>
